import { render, staticRenderFns } from "./Diagnostico.vue?vue&type=template&id=49795612&scoped=true"
import script from "./Diagnostico.vue?vue&type=script&lang=js"
export * from "./Diagnostico.vue?vue&type=script&lang=js"
import style0 from "./Diagnostico.vue?vue&type=style&index=0&id=49795612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49795612",
  null
  
)

export default component.exports